import { betaConfig } from "./betaConfig";
import { devConfig } from "./devConfig";
import { localConfig } from "./localConfig";
import { prodConfig } from "./prodConfig";

const env = process.env.REACT_APP_STAGE;

// const env = 'Dev';

export let enableJira: boolean;
export let enableZendesk: boolean;
export let enableMailReply: boolean;
export let enableInsights: boolean;
export let logLevel: string;
export let enableAnalytics: boolean;
export let enableAiSettingsModelArchitecture: boolean;
export let enableChatbot: boolean;
export let enableFeedback: boolean;
export let enablePlaystore: boolean;
export let enableBugReport: boolean;
export let enableFeatureRequest: boolean;
export let enableCorrelation: boolean;
export let enableDynamicFeedback: boolean;
export let enableRecaptcha: boolean;
export let uploadFileBucketName: string;
export let reCaptchaSiteKey: string;
export let commonEncrypt: any;

if (env === "Dev") {
  enableJira = devConfig.enableJira;
  enableZendesk = devConfig.enableZendesk;
  enableMailReply = devConfig.enableMailReply;
  enableInsights = devConfig.enableInsights;
  logLevel = devConfig.logLevel;
  enableAnalytics = devConfig.enableAnalytics;
  enableAiSettingsModelArchitecture =
    devConfig.enableAiSettingsModelArchitecture;
  enableChatbot = devConfig.enableChatbot;
  enableFeedback = devConfig.enableFeedback;
  enablePlaystore = devConfig.enablePlaystore;
  enableBugReport = devConfig.enableBugReport;
  enableFeatureRequest = devConfig.enableFeatureRequest;
  enableCorrelation = devConfig.enableCorrelation;
  enableDynamicFeedback = devConfig.enableDynamicFeedback;
  enableRecaptcha = devConfig.enableRecaptcha;
  uploadFileBucketName = devConfig.uploadFileBucketName;
  reCaptchaSiteKey = devConfig.reCaptchaSiteKey;
  commonEncrypt = devConfig.commonEncrypt;
} else if (env === "Beta") {
  enableJira = betaConfig.enableJira;
  enableZendesk = betaConfig.enableZendesk;
  enableMailReply = betaConfig.enableMailReply;
  enableInsights = betaConfig.enableInsights;
  logLevel = betaConfig.logLevel;
  enableAnalytics = betaConfig.enableAnalytics;
  enableAiSettingsModelArchitecture =
    betaConfig.enableAiSettingsModelArchitecture;
  enableChatbot = betaConfig.enableChatbot;
  enableFeedback = betaConfig.enableFeedback;
  enablePlaystore = betaConfig.enablePlaystore;
  enableBugReport = betaConfig.enableBugReport;
  enableFeatureRequest = betaConfig.enableFeatureRequest;
  enableCorrelation = betaConfig.enableCorrelation;
  enableDynamicFeedback = betaConfig.enableDynamicFeedback;
  enableRecaptcha = betaConfig.enableRecaptcha;
  uploadFileBucketName = betaConfig.uploadFileBucketName;
  reCaptchaSiteKey = betaConfig.reCaptchaSiteKey;
  commonEncrypt = betaConfig.commonEncrypt;
} else if (env === "Prod") {
  enableJira = prodConfig.enableJira;
  enableZendesk = prodConfig.enableZendesk;
  enableMailReply = prodConfig.enableMailReply;
  enableInsights = prodConfig.enableInsights;
  logLevel = prodConfig.logLevel;
  enableAnalytics = prodConfig.enableAnalytics;
  enableAiSettingsModelArchitecture =
    prodConfig.enableAiSettingsModelArchitecture;
  enableChatbot = prodConfig.enableChatbot;
  enableFeedback = prodConfig.enableFeedback;
  enablePlaystore = prodConfig.enablePlaystore;
  enableBugReport = prodConfig.enableBugReport;
  enableFeatureRequest = prodConfig.enableFeatureRequest;
  enableCorrelation = prodConfig.enableCorrelation;
  enableDynamicFeedback = prodConfig.enableDynamicFeedback;
  enableRecaptcha = prodConfig.enableRecaptcha;
  uploadFileBucketName = prodConfig.uploadFileBucketName;
  reCaptchaSiteKey = prodConfig.reCaptchaSiteKey;
  commonEncrypt = prodConfig.commonEncrypt;
} else {
  enableJira = localConfig.enableJira;
  enableZendesk = localConfig.enableZendesk;
  enableMailReply = localConfig.enableMailReply;
  enableInsights = localConfig.enableInsights;
  logLevel = localConfig.logLevel;
  enableAnalytics = localConfig.enableAnalytics;
  enableAiSettingsModelArchitecture =
    localConfig.enableAiSettingsModelArchitecture;
  enableChatbot = localConfig.enableChatbot;
  enableFeedback = localConfig.enableFeedback;
  enablePlaystore = localConfig.enablePlaystore;
  enableBugReport = localConfig.enableBugReport;
  enableFeatureRequest = localConfig.enableFeatureRequest;
  enableCorrelation = localConfig.enableCorrelation;
  enableDynamicFeedback = localConfig.enableDynamicFeedback;
  enableRecaptcha = localConfig.enableRecaptcha;
  uploadFileBucketName = localConfig.uploadFileBucketName;
  reCaptchaSiteKey = localConfig.reCaptchaSiteKey;
  commonEncrypt = localConfig.commonEncrypt;
}
